import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ListaBienesComponent } from "./list/lista-bienes.component";
import { BienesCulturalesService } from './bienes-culturales.service';
import { from, map, Observable, switchMap, tap } from 'rxjs';
import { FichasRegistroBienesCulturales } from 'app/models/fichaRegistro.model';
import { FiltroListadoComponent } from "./filtro/filtro-listado.component";
import { ArrowBackComponent } from "../../../GlobalComponents/arrow-back.component";
import { UtilsService } from 'app/modules/utils-service';

@Component({
    selector: 'listado-bienes-culturales',
    templateUrl: 'bienes-culturales-list.component.html',
    imports: [
    CommonModule, MatIconModule, ListaBienesComponent,
    ListaBienesComponent,
    FiltroListadoComponent,
    ArrowBackComponent
]
})

export class ListadoBienesCulturalesComponent implements OnInit {
    bienesCulturales$:Observable<FichasRegistroBienesCulturales>

    constructor(
        private bienesService:BienesCulturalesService,
        private utilsService: UtilsService
    ) {
        this.bienesCulturales$= this.bienesService.listBienesCulturales$
    }

    ngOnInit() {
        this.bienesCulturales$ = this.bienesService.listBienesCulturales$.pipe(
            tap(response => {
            response.data.forEach(bien => {
                if (bien.imagenFavorita && bien.imagenFavorita !== 0) {
                this.utilsService.getArchivosInternos(bien.imagenFavorita).then(blobURL => {
                    bien.blobURL = blobURL;
                }).catch(() => {
                    bien.blobURL = null;
                });
                }
            });
            })
        );
    }


}